import LoadingScreen from "../Loading/LoadingScreen.tsx";
import { useUserQuery } from "../../hooks/useUserQuery";
import type { ReactElement } from "react";

const ProtectedRoute = ({ children }: any): ReactElement | null => {

  const { data: user, isLoading } = useUserQuery();

  if (isLoading) {
    return <LoadingScreen fullScreen={true} />;
  }

  if (!user) {
    // user is not authenticated
    window.location.pathname = "/login";
    return null;
  }

  return children as ReactElement;
};

export default ProtectedRoute;
